/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRankData
 */
export interface UserRankData {
    /**
     * 
     * @type {string}
     * @memberof UserRankData
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof UserRankData
     */
    pfpUrl: string;
    /**
     * 
     * @type {number}
     * @memberof UserRankData
     */
    level: number;
    /**
     * 
     * @type {number}
     * @memberof UserRankData
     */
    rank: number;
    /**
     * 
     * @type {number}
     * @memberof UserRankData
     */
    experiencePoints: number;
}

/**
 * Check if a given object implements the UserRankData interface.
 */
export function instanceOfUserRankData(value: object): value is UserRankData {
    if (!('nickname' in value) || value['nickname'] === undefined) return false;
    if (!('pfpUrl' in value) || value['pfpUrl'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('experiencePoints' in value) || value['experiencePoints'] === undefined) return false;
    return true;
}

export function UserRankDataFromJSON(json: any): UserRankData {
    return UserRankDataFromJSONTyped(json, false);
}

export function UserRankDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRankData {
    if (json == null) {
        return json;
    }
    return {
        
        'nickname': json['nickname'],
        'pfpUrl': json['pfpUrl'],
        'level': json['level'],
        'rank': json['rank'],
        'experiencePoints': json['experiencePoints'],
    };
}

export function UserRankDataToJSON(json: any): UserRankData {
    return UserRankDataToJSONTyped(json, false);
}

export function UserRankDataToJSONTyped(value?: UserRankData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nickname': value['nickname'],
        'pfpUrl': value['pfpUrl'],
        'level': value['level'],
        'rank': value['rank'],
        'experiencePoints': value['experiencePoints'],
    };
}

